var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#D03450"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4343_62848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 14.25L18 12.75L14.25 14.25L13.5 17.625C17.0552 17.0597 18.9808 17.0733 22.5 17.625L21.75 14.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13.5C16.9557 13.5 15.9542 13.9148 15.2158 14.6533C14.4773 15.3917 14.0625 16.3932 14.0625 17.4375C14.0625 17.7482 13.8107 18 13.5 18C13.1893 18 12.9375 17.7482 12.9375 17.4375C12.9375 16.0948 13.4709 14.8072 14.4203 13.8578C15.3697 12.9084 16.6573 12.375 18 12.375C19.3427 12.375 20.6303 12.9084 21.5797 13.8578C22.5291 14.8072 23.0625 16.0948 23.0625 17.4375C23.0625 17.7482 22.8107 18 22.5 18C22.1893 18 21.9375 17.7482 21.9375 17.4375C21.9375 16.3932 21.5227 15.3917 20.7842 14.6533C20.0458 13.9148 19.0443 13.5 18 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.4375C9 17.1268 9.25184 16.875 9.5625 16.875H11.25C11.5607 16.875 11.8125 17.1268 11.8125 17.4375C11.8125 17.7482 11.5607 18 11.25 18H9.5625C9.25184 18 9 17.7482 9 17.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1875 17.4375C24.1875 17.1268 24.4393 16.875 24.75 16.875H26.4375C26.7482 16.875 27 17.1268 27 17.4375C27 17.7482 26.7482 18 26.4375 18H24.75C24.4393 18 24.1875 17.7482 24.1875 17.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18.3107 9 18.5625 9.25184 18.5625 9.5625V11.25C18.5625 11.5607 18.3107 11.8125 18 11.8125C17.6893 11.8125 17.4375 11.5607 17.4375 11.25V9.5625C17.4375 9.25184 17.6893 9 18 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0227 11.4148C24.2424 11.6344 24.2424 11.9906 24.0227 12.2102L22.8977 13.3352C22.6781 13.5549 22.3219 13.5549 22.1023 13.3352C21.8826 13.1156 21.8826 12.7594 22.1023 12.5398L23.2273 11.4148C23.4469 11.1951 23.8031 11.1951 24.0227 11.4148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9773 11.4148C12.1969 11.1951 12.5531 11.1951 12.7727 11.4148L13.8977 12.5398C14.1174 12.7594 14.1174 13.1156 13.8977 13.3352C13.6781 13.5549 13.3219 13.5549 13.1023 13.3352L11.9773 12.2102C11.7576 11.9906 11.7576 11.6344 11.9773 11.4148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5102 19.43C12.9666 18.9931 15.1304 18.5625 18 18.5625C20.8696 18.5625 23.0334 18.9931 24.4898 19.43C25.2176 19.6483 25.7681 19.8681 26.141 20.0359C26.3274 20.1198 26.4695 20.1907 26.5671 20.242C26.616 20.2676 26.6537 20.2883 26.6803 20.3033C26.6936 20.3108 26.7042 20.3168 26.7119 20.3213L26.7215 20.3269L26.7247 20.3289L26.7259 20.3296L26.7265 20.3299C26.7267 20.33 26.7269 20.3302 26.4375 20.8125L26.7269 20.3302C26.8963 20.4318 27 20.6149 27 20.8125V26.4375C27 26.7482 26.7482 27 26.4375 27H9.5625C9.25184 27 9 26.7482 9 26.4375V20.8125C9 20.6149 9.10367 20.4318 9.2731 20.3302L9.5625 20.8125C9.2731 20.3302 9.27331 20.33 9.27354 20.3299L9.27406 20.3296L9.27528 20.3289L9.2785 20.3269L9.28807 20.3213C9.29583 20.3168 9.30637 20.3108 9.31969 20.3033C9.34631 20.2883 9.38404 20.2676 9.43287 20.242C9.53052 20.1907 9.67257 20.1198 9.85901 20.0359C10.2319 19.8681 10.7824 19.6483 11.5102 19.43ZM9.85152 21.2951L9.85075 21.2955L9.8512 21.2953L9.85152 21.2951ZM10.125 21.153C10.1815 21.1257 10.2467 21.0951 10.3207 21.0618C10.6509 20.9132 11.1551 20.711 11.8335 20.5075C13.1896 20.1007 15.2446 19.6875 18 19.6875C20.7554 19.6875 22.8104 20.1007 24.1665 20.5075C24.8449 20.711 25.3491 20.9132 25.6793 21.0618C25.7533 21.0951 25.8185 21.1257 25.875 21.153V25.875H10.125V21.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.456 18.9013C14.7338 19.0403 14.8464 19.3781 14.7075 19.656L11.1907 26.6887C11.0518 26.9666 10.7139 27.0792 10.436 26.9403C10.1582 26.8013 10.0456 26.4634 10.1845 26.1856L13.7013 19.1528C13.8402 18.875 14.1781 18.7624 14.456 18.9013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4913 18.6171C16.7978 18.6682 17.0048 18.958 16.9537 19.2645L15.7424 26.5297C15.6913 26.8361 15.4015 27.0431 15.0951 26.9921C14.7887 26.941 14.5817 26.6511 14.6327 26.3447L15.844 19.0795C15.8951 18.773 16.1849 18.566 16.4913 18.6171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5454 18.9013C21.8233 18.7624 22.1612 18.875 22.3001 19.1528L25.8169 26.1856C25.9558 26.4634 25.8432 26.8013 25.5653 26.9403C25.2875 27.0792 24.9496 26.9666 24.8106 26.6887L21.2939 19.656C21.155 19.3781 21.2676 19.0403 21.5454 18.9013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5091 18.6171C19.8156 18.566 20.1054 18.773 20.1565 19.0795L21.3677 26.3447C21.4188 26.6511 21.2118 26.941 20.9054 26.9921C20.599 27.0431 20.3091 26.8361 20.2581 26.5297L19.0468 19.2645C18.9957 18.958 19.2027 18.6682 19.5091 18.6171Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4343_62848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.9f372f1402dfbdb01a7ef710c5440b8a.svg";
export { ForwardRef as ReactComponent };